import React from 'react'
import classes from './Legend.module.scss'

export const Legend: React.FunctionComponent = ({ children }) => (
  <legend className={classes.legend}>{children}</legend>
)
